export default [
    {
        path: "auto-onboarding",
        component: () =>
            import(
                /* webpackChunkName: "auto_onboarding_layout" */ "@modules/AutoOnboarding/views/Layout.vue"
                ),
        meta: {
            requiresAuth: false,
            title: "auto_onboarding"
        },
        children: [
            {
                path: "verification",
                name: "AutoOnboardingVerification",
                component: () =>
                    import(
                        /* webpackChunkName: "auto_onboarding_verification" */ "@modules/AutoOnboarding/views/Verification.vue"
                        ),
                meta: { requiresAuth: false, title: "auto_onboarding_verification_title" }
            },
            {
                path: "confirmation",
                name: "AutoOnboardingConfirmation",
                component: () =>
                    import(
                        /* webpackChunkName: "auto_onboarding_confirmation" */ "@modules/AutoOnboarding/views/Confirmation.vue"
                        ),
                meta: { requiresAuth: false, title: "auto_onboarding_confirmation_title" }
            },
            {
                path: "new-customer",
                name: "AutoOnboardingNewCustomer",
                component: () =>
                    import(
                        /* webpackChunkName: "auto_onboarding_new_customer" */ "@modules/AutoOnboarding/views/NewCustomer.vue"
                        ),
                meta: { requiresAuth: false, title: "auto_onboarding_new_customer_title" }
            },
            {
                path: "survey",
                name: "AutoOnboardingSurvey",
                component: () =>
                    import(
                        /* webpackChunkName: "auto_onboarding_survey" */ "@modules/AutoOnboarding/views/Survey.vue"
                        ),
                meta: { requiresAuth: false, title: "auto_onboarding_survey_title" }
            },
            {
                path: "summary",
                name: "AutoOnboardingSummary",
                component: () =>
                    import(
                        /* webpackChunkName: "auto_onboarding_summary" */ "@modules/AutoOnboarding/views/Summary.vue"
                        ),
                meta: { requiresAuth: false, title: "auto_onboarding_summary_title" }
            },
            {
                path: "thank-you",
                name: "AutoOnboardingThankYou",
                component: () =>
                    import(
                        /* webpackChunkName: "auto_onboarding_thank_you" */ "@modules/AutoOnboarding/views/ThankYou.vue"
                        ),
                meta: { requiresAuth: false, title: "auto_onboarding_thank_you_title" }
            }
        ]
    }
];
